import { changeSkin } from '@/utils/common.js';
import HomeService from '../service.js';
// import Service from '@/service/index.js';
import { mapGetters } from 'vuex';
import { landUnitByType } from '@/utils/common.js';
export default {
  components: {
  },
  data () {
    return {
      // projectTypeList: [],
      transactionTypeList: [],
      search: {
        project: '',
        transaction: ''
      },
      transctionProjectType: [],
      projectList: [],
      otherLength: 0,
      len: 0,
      landUnitByType: landUnitByType
    };
  },
  computed: {
    ...mapGetters([
      'projectTypeList'
    ])
  },
  created () {
    this.transctionProjectType = this.projectTypeList;
    // console.log(this.transctionProjectType, 'this.transctionProjectType');
    // console.log(this.projectTypeList, 'projectTypeList');
    // Service.getSelectList('PROJECT_TYPE').then(res => {
    //   if (res && res.code === '0') {
    //     this.transctionProjectType = res.data;
    //   }
    // });
    console.log(localStorage.areaCode || localStorage.areaCode || localStorage.areaCode, 66);
    if (localStorage.areaCode || localStorage.areaCode || localStorage.areaCode) {
      this.getList();
    } else {
      console.log('@');
      this.getNewsList();
    }
  },
  methods: {
    changeSkin,
    // 如果是省
    getNewsList () {
      let params = {
        type: 1,
        partId: '3',
        pageNum: 1,
        pageSize: 5
      };
      HomeService.getNewsList(params).then(res => {
        // console.log(res, 999);

        if (res && res.code === '0') {
          let list = res.data;
          let num = 4 - res.data.size;
          HomeService.getRecommendProject(4).then(res => {
            if (res && res.code === '0') {
              this.projectList = [
                ...list.list,
                ...res.data
              ];
              this.len = 4 - this.projectList.length;
            }
          });
          if (num > 0) {
            // let key = '';
            // if (Number(localStorage.level) === 2) {
            //   key = 'city';
            // } else if (Number(localStorage.level) === 3) {
            //   key = 'county';
            // } else if (Number(localStorage.level) === 4) {
            //   key = 'township';
            // }

          } else {
            this.projectList = [
              ...list.list
            ];
          }
        }
      });
    },
    // 子网站不获取新闻列表
    getList () {
      let key = '';
      if (Number(localStorage.level) === 2) {
        key = 'city';
      } else if (Number(localStorage.level) === 3) {
        key = 'county';
      } else if (Number(localStorage.level) === 4) {
        key = 'township';
      }
      HomeService.getRecommendProject(4, key, localStorage.areaCode).then(res => {
        if (res && res.code === '0') {
          this.projectList = res.data;
          this.len = 4 - this.projectList.length;
        }
      });
    },
    goDetail (id, status) {
      window.open(window.location.origin + '/#/transaction-pro/detail?id=' + id + '&status=' + status);
    },
    goNewDetail (id) {
      window.open(window.location.origin + '/#/news/news-detail-recommend?id=' + id);
    },
    getProjectStatusStyle (status) {
      if (status === 42) {
        return 'background: #F7B500';
      } else if (status === 60) {
        return 'background: #00B58D';
      } else if (status === 51) {
        return 'background: #0DCE03';
      } else if (status === 50) {
        return 'background: #FA5741';
      } else if (status === 70 || status === 95) {
        return 'background: #383838';
      }
    }
  }
};
